import { ArrowLeft, Factory, File } from "@phosphor-icons/react";
import ContentContainer from "../components/ContentContainer";
import IconButton from "../components/IconButton";
import MainLayout from "../components/MainLayout/MainLayout";
import Typography from "../components/Typography";
import Separator from "../components/Separator";
import EvidenceHistoryTimeline from "../components/EvidenceHistoryTimeline/EvidenceHistoryTimeline";
import { useParams } from "react-router-dom";
import {
    useEmissionsSourceEvidenceHistory,
    useEvidenceTypes,
} from "../api/evidence";
import { useEmissionsSourceById } from "../api/emissions-sources";

const EmissionsSourceEvidenceHistoryPage = () => {
    const { emissionsSourceId, evidenceTypeId } = useParams();
    const {
        evidence,
        gaps,
        isLoading: isLoadingEvidenceHistory,
    } = useEmissionsSourceEvidenceHistory(
        Number(evidenceTypeId),
        Number(emissionsSourceId)
    );
    const { evidenceTypes, isLoading: isLoadingEvidenceTypes } =
        useEvidenceTypes();
    const { emissionsSource, isLoading: isLoadingDataSource } =
        useEmissionsSourceById(Number(emissionsSourceId));

    const evidenceTypeDetails = evidenceTypes.find(
        (evidenceType) => evidenceType.id === Number(evidenceTypeId)
    );

    return (
        <MainLayout
            isLoading={
                isLoadingEvidenceHistory ||
                isLoadingEvidenceTypes ||
                isLoadingDataSource
            }
        >
            <ContentContainer className="pt-14 pb-11">
                <div className="flex flex-col gap-6 sm:gap-0 sm:flex-row items-center pb-5">
                    <div className="flex items-center">
                        <IconButton
                            label="Back"
                            icon={ArrowLeft}
                            iconSize="large"
                            className="mr-3"
                            onClick={() => window.history.back()}
                        />
                        <Typography variant="headline-small" component="h1">
                            Evidence history
                        </Typography>
                    </div>
                    <div className="sm:ml-auto flex flex-col sm:flex-row items-center gap-6">
                        <div className="flex items-center gap-3 font-semibold text-deep-ocean-20">
                            <File size={26} />
                            <div>
                                <Typography variant="label-small" component="p">
                                    Evidence type:
                                </Typography>
                                <Typography
                                    variant="title-medium"
                                    component="p"
                                >
                                    {evidenceTypeDetails?.name}
                                </Typography>
                            </div>
                        </div>
                        <div className="flex items-center gap-3 font-semibold text-deep-ocean-20">
                            <Factory size={26} />
                            <div>
                                <Typography variant="label-small" component="p">
                                    Asset
                                </Typography>
                                <Typography
                                    variant="title-medium"
                                    component="p"
                                >
                                    {emissionsSource?.name}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <Separator className="mb-8" />
                <EvidenceHistoryTimeline data={{ evidence, gaps }} />
            </ContentContainer>
        </MainLayout>
    );
};

export default EmissionsSourceEvidenceHistoryPage;
